// extracted by mini-css-extract-plugin
export default {"advertDetailHeader":"c-o_fO"};